'use client';
import { FiSearch } from 'react-icons/fi';
import { buildToursSearchParams, useTourStore } from '../../stores/tours-store';
import { TourFilterDates } from './tour-filter-fields/tour-filter-dates';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { TourFilterGuests } from './tour-filter-fields/tour-filter-guests';
import { TourSidebarFilterTrigger } from './tour-sidebar-filter/tour-sidebar-filter-trigger';
import { TourSidebarFilterDates } from './tour-sidebar-filter/tour-sidebar-filter-fields/tour-sidebar-filter-dates';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useRouter } from 'next/navigation';
import { TourFilterTours } from './tour-filter-fields/tour-filter-tours';
import { TourSidebarFilterTours } from './tour-sidebar-filter/tour-sidebar-filter-fields/tour-sidebar-filter-tours';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export const ToursFilterHomepage = () => {
  const { filter, applyFilter } = useTourStore();
  const { t } = useTranslations();
  const router = useRouter();
  const locale = useLocaleStore(state => state.currentLocale);

  const handleRedirectToTours = () => {
    router.push(`${ROUTES.TOURS(locale)}?${buildToursSearchParams(filter)}`);
  };

  return (
    <div className="flex w-full flex-col items-start justify-start gap-4 sm:gap-6 lg:gap-8">
      <div className="z-10 flex w-full flex-col items-start justify-start gap-4">
        <div className="relative z-10 hidden h-20 w-full items-center rounded-[16px] bg-white p-1 md:flex">
          {/* TourFilterCtegories */}
          <div className="flex-1">
            <TourFilterTours />
          </div>

          {/* TourFilterDates */}
          <div className="flex-1">
            <TourFilterDates />
          </div>

          {/* Search Button */}
          <div className="h-full w-[130px]">
            <Button className="h-full w-full" onClick={() => handleRedirectToTours()}>
              <FiSearch className="h-5 w-5 text-white" /> {t('text1')}
            </Button>
          </div>
        </div>
        <div className="flex w-full flex-col gap-4 md:hidden">
          <TourSidebarFilterTours noLabel />
          <TourSidebarFilterDates noLabel />
        </div>
        <div className="flex items-center justify-start gap-2">
          <TourFilterGuests />
          <TourSidebarFilterTrigger />
        </div>
        <Button className="h-12 w-full md:hidden" onClick={() => handleRedirectToTours()}>
          <FiSearch className="h-5 w-5 text-white" /> {t('text1')}
        </Button>
      </div>
    </div>
  );
};
